export const iconFontAwesomeMediaplaybackRotateRight = (
	<i className="fa-solid fa-rotate-right"></i>
);
